// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29uBU","rootNoMargin":"styles_rootNoMargin__25sXl"};